import { type FC, type ReactNode } from "react";
import { Header } from "./Header";
import { UserMenu } from "./Header/CurrentUser/UserMenu";
import { Notifications } from "./Header/Notifications/Notifications";
import { Navigation } from "./Navigation/Navigation";

export const ContentWrapper: FC<{
    children: ReactNode;
    menuItems: ReactNode;
}> = ({ children, menuItems }) => {
    return (
        <>
            <Header />
            <Navigation items={menuItems} />
            <UserMenu />
            <Notifications />
            {children}
        </>
    );
};
